// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules_dev/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h2[data-v-10c87219]{margin-bottom:30px}img[data-v-10c87219]{max-width:100%}", ""]);
// Exports
module.exports = exports;
